import './RadioButton.scss';
import React, { FunctionComponent } from 'react';

type Props = {
  label?: string;
  value?: string;
  id?: string;
  name?: string;
  checked?: boolean;
  input: React.ReactNode;
  ariaLabel: string;
};

export const RadioButton: FunctionComponent<Props> = ({
  label,
  id,
  value,
  name,
  checked,
  input,
  ariaLabel,
}) => {
  return (
    <div className="jg-display-flex jg-flex-aic jg-space-ptsm">
      <label htmlFor={id}>
        <input
          type="radio"
          id={id}
          value={value}
          name={name}
          {...input}
          checked={checked}
          aria-label={ariaLabel}
          className="radio jg-space-mrsm"
        />
        {label}
      </label>
    </div>
  );
};
